import React from "react";

const PrivacyNotice = () => {
  return (
    <div className="bg-white p-5 text-justify">
      <div className="d-flex justify-content-end pt-5">
        <a href="/cookie-policy" className="pr-5">
          Cookie policy
        </a>
        <a href="/customer-awareness-policy" className="pr-5">
          Customer awareness policy
        </a>
      </div>
      <h1>PRIVACY NOTICE</h1>
      <div className="pt-3">
            This Privacy Notice applies to the Avitech Software Solutions website inquiry 
            page(www.avitechng.com). The privacy of our Users is important to us, and we 
            are committed to safeguarding it. Hence, this Privacy Notice explains the 
            Personal Information which we collect, why we collect it, and what we do with it. 
      </div>
      <h6 className="pt-5">PERSONAL DATA COLLECTED: (NAME AND EMAIL ADDRESS)</h6>
      <div>
        <h6 className="pt-4">PURPOSE OF PROCESSING </h6>
        <p>We do not carry out automated decision-making on personal data collected. We process personal data based on consent to:</p>
        <ol>
          <li className="pt-2">
            Respond to your inquiries and fulfill your requests. 
          </li>
          <li className="pt-2">
            Deliver marketing communications about our products and services.
          </li>
          <li className="pt-2">
            Carry out marketing analysis and make general improvements to our Site. 
          </li>
        </ol>
        <h6 className="pt-4">Retention Period</h6>
            <p>
                Avitech Software Solutions only stores data for the purpose which it was collected for. 
                Personal data are stored Quaterly with appropriate technical and organizational measures 
                subject to legal and regulatory requirements. 
            </p>
            
            <h6 className="pt-4">Further Processing</h6>
            <p>
                Avitech Software Solutions shall request for data subject consent for additional processing 
                of personal data other than the lawful purpose of processing stated above.  
            </p>

            <p className="pt-3">
                Kindly refer to our <a href="/privacy-policy" target="_blank">Privacy Policy </a>for more details on our data privacy and protection culture.
            </p>

            <p className="pt-3">
                By clicking “SUBMIT” you agree Avitech Software Solutions 
                can collect and process your personal data in accordance to this 
                <a href="/privacy-notice" target="_blank"> privacy notice</a> and our 
                website <a href="/privacy-policy" target="_blank">privacy policy</a>.  
            </p>
          </div>
      <div className="pt-3"> Date of last revision: 1st June 2021</div>
    </div>
  );
};

export default PrivacyNotice;




{/* <div className="pt-3">
            This Privacy Notice applies to the Trips Software Solutions website 
            inquiry page(www.trips.ng). The privacy of our Users is 
            important to us, and we are committed to safeguarding it. Hence, this 
            Privacy Notice explains the Personal Information which we collect, 
            why we collect it, and what we do with it. 
          </div>
          <h6 className="pt-5">PERSONAL DATA COLLECTED: (NAME AND EMAIL ADDRESS)</h6>
          <p>We do not carry out automated decision-making on personal data collected. We process personal data based on consent to: </p>
          <div>
            <ol>
              <li className="pt-2">
                Respond to your inquiries and fulfill your requests.
              </li>
              <li className="pt-2">
                Deliver marketing communications about our products and services.
              </li>
              <li className="pt-2">
                Carry out marketing analysis and make general improvements to our Site.
              </li>
            </ol>

            <h6 className="pt-4">Retention Period</h6>
            <p>
                Trips Software Solutions only stores data for the purpose which it was collected for. 
                Personal data are stored Quaterly with appropriate technical and organizational measures 
                subject to legal and regulatory requirements. 
            </p>
            
            <h6 className="pt-4">Further Processing</h6>
            <p>
                Trips Software Solutions shall request for data subject consent for additional processing 
                of personal data other than the lawful purpose of processing stated above.  
            </p>

            <p className="pt-3">
                Kindly refer to our 
                <Link href="/privacy-policy" target="_blank" className={styles.privacyPolicyLink}>Privacy Policy</Link> 
                for more details on our data privacy and protection culture.
            </p>

            <p className="pt-3">
                By clicking “SUBMIT” you agree Trips Software Solutions 
                can collect and process your personal data in accordance to this 
                <Link href="/privacy-notice" target="_blank" className={styles.privacyPolicyLink}> privacy notice</Link> and our 
                website <Link href="/privacy-policy" target="_blank" className={styles.privacyPolicyLink}>privacy policy</Link>.  
            </p>
          </div> */}


// WEBPACK FOOTER //
// ./src/views/policies/privacy-notice.js